import { Component, OnInit, Input } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { faDollyFlatbed } from '@fortawesome/free-solid-svg-icons';
import { ControllerForViewBase } from '../framework/controller-for-view-base';
import { PageContainerService } from '../../services';
import {
  MaterialsStageStatusDto,
} from "../../data/CommandServiceDtos.generated";

@Component({
  selector: 'project-summary-materials',
  templateUrl: './project-summary-materials.component.html',
  styleUrls: ['./project-summary-materials.component.scss']
})
export class ProjectSummaryMaterialsComponent implements OnInit {
  @Input() materialsSummary: MaterialsStageStatusDto;
  materialsOverallComplete: number;
  materialsAccessUrl: string;
  faMaterialLink = faDollyFlatbed;
  data: any[];


  constructor(private pcs: PageContainerService) {
  }

  ngOnInit() {
    this.materialsOverallComplete = this.materialsSummary.PercentComplete;
    this.materialsAccessUrl = this.materialsSummary.MaterialsAccessUrl;
  }

  drilldownMaterials() {
    if (this.materialsAccessUrl === null) {
      this.pcs.notificationService.warning("Materials management not configured for this Project", "", { timeOut: 3000 });
      return;
    }

    window.open(this.materialsAccessUrl, "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/app/components/project-summary-materials/project-summary-materials.component.ts